<template>
  <div id="puplist">
    <div class="pupitem" v-for="pup in pups" v-bind:key="pup.id">
      <div><span><i class="marker fa fa-map-marker-alt fa-3x"></i></span></div>
      <div class="adr"><strong>
        <span> {{ pup.name }}</span>
      </strong>
      <span class="adress"> {{ pup.visitingAddress }} </span>
      <span class="adress"> {{ pup.visitingPostalCode }}  {{ pup.visitingCity }}</span></div>
      <div><strong><span>Opening Hours:</span></strong><span class="openinghours"> {{ pup.openingHoursEnglish}} </span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'puplist',
  props: ['pups']
}
</script>

<style>
#puplist {
  width: 49%;
  text-align: left;
  display: inline-block;
}
svg.svg-inline--fa.fa-map-marker-alt.fa-w-12.fa-3x {
    color: red;
}
.pupitem {
    width: 100%;
    display: block;
    border:  1px solid gray;
    padding-top: 1px;
    padding-bottom: 1px;
}
.pupitem div {
    display: inline-block;
    width: 40%;
}
.pupitem div:first-of-type {
    display: inline-block;
    width: 10%;
    vertical-align: top;
    padding: 6px 1px 0px 0px;
}
.pupitem div:last-of-type {
    display: inline-block;
    width: 45%;
    vertical-align: top;
}
.pupitem span {
  display: block;
}
.adr {
    text-align: left;
    vertical-align: text-bottom;
}
span.adress {
    font-size: 0.82em;
}
</style>



// WEBPACK FOOTER //
// src/components/puplist.vue